module.exports = __webpack_public_path__ + "static/img/remixicon.symbol.f09b1c74.f09b1c74.svg";